module.exports = __webpack_public_path__ + "static/img/section-next.c9a4bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/h5/imgs/section-next.png
// module id = I/Be
// module chunks = 13